import { BookOpenCheck } from "lucide-react";
import { theme } from "../theme";
import { playbookPath, usePlaybooks } from "../lib/playbooks";
import { ShellLink } from "./ShellLink";

/**
 * "Playbook: Incident response" — a register page's way into the good practice behind it.
 * Renders nothing when the organisation's edition does not carry the playbook.
 */
export function PlaybookLink({ id }: { id: string }) {
  const list = usePlaybooks();
  const pb = list?.find((p) => p.id === id);
  if (!pb) return null;
  return (
    <ShellLink
      to={playbookPath(pb.id)}
      title={pb.summary}
      style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 600, color: theme.color.accentText, textDecoration: "none" }}
    >
      <BookOpenCheck size={14} /> Playbook: {pb.title}
    </ShellLink>
  );
}
